<template lang='pug'>
v-card(xs12).card-style
  v-snackbar(:value='activeContactsError', color='error')
    div {{ activeContactsErrorMessage }}
  v-flex
    v-flex.centered.title-style ACTIVE CONTACTS
    v-flex.centered Your contacts who are currently active in a Qualify conversation.
  v-flex.centered
    v-icon.number-graph.icon groups
    span.number-graph {{activeContacts}}
    v-flex.pa-0.ma-0.loadingDialog(v-if="activeContactsInProgress") Loading...
</template>
  
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapQualifyGetters } = createNamespacedHelpers('qualify');
const { mapGetters: mapLeadsplusGetters } = createNamespacedHelpers('leadsplus');
const { mapActions: mapReportingActions, mapState: mapReportingState } = createNamespacedHelpers('reportingQualify');

export default {
  name: 'ActiveContactsWidget',
  data() {
    return {
      activeContacts: 0,
      contactsList: [],
    }
  },
  computed: {
    ...mapQualifyGetters(['isIntegrationConnected']),
    ...mapLeadsplusGetters({ isLeadsplusIntegrationConnected: 'isIntegrationConnected' }),
    ...mapReportingState(['activeContactsTotal', 'activeContactsIds', 'activeContactsInProgress', 'activeContactsError', 'activeContactsErrorMessage']),
    watchedValue() {
      return `${this.activeContacts}|${this.contactsList}`;
    }
  },
  created() {
    this.getWidgetData()
  },
  watch: {
    watchedValue: {
      handler() {
        this.getWidgetData();
      }
    },
    isLeadsplusIntegrationConnected: {
      handler() {
        this.getWidgetData();
      }
    }
  },
  methods: {
    ...mapReportingActions(['getActiveContactsQualify']),
    async getWidgetData() {
      if (!this.isLeadsplusIntegrationConnected) {
        this.loadMockData();
        return;
      }

      if (!this.isIntegrationConnected || this.activeContactsInProgress) {
        this.loadEmptyData();
        return;
      }

      const querySettings = { leadsource: 'leadsplus' };
      await this.getActiveContactsQualify(querySettings);
      this.loadRealData();
    },
    loadMockData() {
      this.activeContacts = 10;
      this.contactsList = [];
    },
    loadRealData() {
      this.activeContacts = this.activeContactsTotal;
      this.contactsList = this.activeContactsIds;
    },
    loadEmptyData() {
      this.activeContacts = 0;
      this.contactsList = [];
    }
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  padding: 15px;
}

.centered {
  display: flex;
  justify-content: center;
}

.title-style {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.number-graph {
  font-size: 64px;
}

.loadingDialog {
  position: absolute;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  font-weight: bold;
  font-size: 16px;
}
</style>
